import { render, staticRenderFns } from "./FieldsetContainer2.vue?vue&type=template&id=b5c95e06"
import script from "./FieldsetContainer2.vue?vue&type=script&lang=js"
export * from "./FieldsetContainer2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports